// ============================================================================
// Petty Cash — catálogo de contas contábeis de despesa (fonte única)
// ----------------------------------------------------------------------------
// Esta lista estava DUPLICADA em `FinanceiroPettyCashFormulario.js` e
// `FinanceiroPettyCashAuditoria.js`. Em 2026-08-06 a conta de pedágio foi
// renomeada em apenas um dos dois arquivos, e isso quase derrubou uma tela:
// o filtro por categoria da Auditoria compara o texto daqui com a `DESCRICAO`
// **gravada no banco**, então a categoria renomeada passaria a devolver ZERO
// linhas — as 17 despesas antigas sumiriam sem erro nenhum.
//
// ⚠️ O NOME É DADO, NÃO É RÓTULO DE TELA. O `POST /submit` grava `desc` por
// extenso na coluna `DESCRICAO` de cada lançamento, e o lote SAP usa esse texto
// como nome da conta. Portanto, renomear uma conta aqui NÃO basta: os
// lançamentos já gravados continuam com a grafia antiga e saem do filtro.
// Renomear = mudar aqui **e** atualizar as linhas existentes no banco:
//
//   UPDATE dtbPettyCash SET DESCRICAO = '<novo>'
//    WHERE CONTA_DESPESA = '<conta>' AND DESCRICAO = '<antigo>';
//
// A `CONTA_DESPESA` (o código) é a chave estável — ela nunca muda.
// ============================================================================

export const categoriasDespesa = [
    { conta: '41180500000014', desc: 'PEDAGIOS E ESTACIONAMENTO' },
    { conta: '41180100000003', desc: 'FOTOCOPIAS E ENCADERNACOES' },
    { conta: '41110600000001', desc: 'INCENTIVO PARA FUNCIONARIOS' },
    { conta: '41110600000002', desc: 'INCENTIVOS DE VENDAS' },
    { conta: '41160100000002', desc: 'MATERIAS DE MANUTENCAO' },
    { conta: '41150100000004', desc: 'MATERIAL DE CONSUMO' },
    { conta: '41110600000011', desc: 'MEDICAMENTO' },
];

export default categoriasDespesa;
